module.exports = __webpack_public_path__ + "images/index/img04.2ce3959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/yuichi/img04.jpg
// module id = F5mR
// module chunks = 21